import React from "react";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { Box, alpha, useTheme } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { completeUserAuth } from "../../utils/postLoginRedirect";
import {
  clearStoredReferralCode,
  getStoredReferralCode,
} from "../../utils/referralAttribution";

const UserLoginGoogle = ({ hitAxios, web, returnTo, requirePlan }) => {
  const theme = useTheme();
  const history = useHistory();

  async function runLogin(token) {
    if (typeof requirePlan === "function" && !requirePlan()) return;
    const res = await hitAxios({
      path: "/api/user/login_with_google",
      post: true,
      admin: false,
      obj: {
        token,
        referral_code: getStoredReferralCode() || undefined,
      },
      showLoading: false,
    });
    if (res?.data?.success && res.data.token) {
      if (res.data.isNewAccount) {
        clearStoredReferralCode();
        try {
          const { trackSignUp } = await import("../../common/tracking");
          trackSignUp({ method: "google" });
        } catch {
          /* non-fatal */
        }
      }
      await completeUserAuth({
        token: res.data.token,
        hitAxios,
        history,
        isNewAccount: Boolean(res.data.isNewAccount),
        returnTo,
      });
    }
  }

  if (!web?.google_login_id) return null;

  return (
    <GoogleOAuthProvider clientId={web.google_login_id}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          "& > div": { width: "100% !important" },
          "& iframe": { margin: "0 auto !important" },
          "& [role='button']": {
            width: "100% !important",
            maxWidth: "100% !important",
            borderRadius: `${theme.shape.borderRadius * 1.5}px !important`,
            border: `1px solid ${theme.palette.divider} !important`,
            boxShadow: `${theme.shadows[1]} !important`,
            transition: "box-shadow 0.2s ease, transform 0.2s ease !important",
          },
          "& [role='button']:hover": {
            boxShadow: `${theme.shadows[4]} !important`,
            transform: "translateY(-1px)",
            bgcolor: `${alpha(theme.palette.primary.main, 0.04)} !important`,
          },
        }}
      >
        <GoogleLogin
          text="continue_with"
          size="large"
          width="400"
          onSuccess={(creds) => {
            if (creds.credential) {
              runLogin(creds.credential);
            }
          }}
          onError={() => {
            console.warn("Google login failed");
          }}
        />
      </Box>
    </GoogleOAuthProvider>
  );
};

export default UserLoginGoogle;
